// // import React from "react";
// // import { Box, Container, Typography, Paper, } from "@mui/material";
// // import qr from "../../images/QR.jpeg";

// // const ContactHero = () => {
// //   return (
// //     <Container
// //       maxWidth="md"
// //       sx={{
// //         py: 6,
// //         fontFamily: "Poppins, sans-serif",
// //       }}
// //     >
// //       <Paper
// //         elevation={0}
// //         sx={{
// //           p: 4,
// //           borderRadius: 2,
// //           border: "1px solid #ddd",
// //           textAlign: "center",
// //           fontFamily: "Poppins, sans-serif",
// //         }}
// //       >
// //         {/* Title Section */}
// //         <Typography
// //           variant="h4"
// //           fontWeight={600}
// //           gutterBottom
// //           sx={{ fontFamily: "Poppins, sans-serif" }}
// //         >
// //           Questions or Concerns?
// //         </Typography>

// //         {/* Description Section */}
// //         <Typography
// //           variant="body1"
// //           sx={{ mb: 3, fontFamily: "Poppins, sans-serif" }}
// //         >
// //           Feel free to contact us with any questions or inquiries about Yoga therapy classes for private consultations with a mindful approach, specializing in stress-related conditions such as adrenal fatigue, IBS, insomnia, depression, anxiety, weight loss, and overall fitness.
// //         </Typography>

// //         <Typography
// //           variant="body1"
// //           sx={{ mb: 4, fontFamily: "Poppins, sans-serif" }}
// //         >
// //           Our sessions help people overcome stress, back and knee pain, anxiety, hypertension, depression, and psychosomatic disorders. Learn more about our class schedules.
// //         </Typography>

// //         {/* Contact Information Section */}
// //         <Box
// //           sx={{
// //             my: 4,
// //             textAlign: "left",
// //             fontFamily: "poppins, sans-serif",
// //           }}
// //         >
// //           <Typography variant="h6" fontWeight={600} gutterBottom sx={{ fontFamily: "poppins" }}>
// //             Contact Information:
// //           </Typography>
// //           <Typography sx={{ fontFamily: "poppins" }}>Email: pranayoga.us@gmail.com</Typography>

// //           <Typography sx={{fontFamily:"poppins"}}>Phone: 425-524-2725</Typography>
// //           <Typography sx={{fontFamily:"poppins"}}>Location: Prana Yoga and Meditation, Naperville, IL</Typography>
// //         </Box>

// //         {/* Class Schedules Section */}
// //         <Box
// //           sx={{
// //             my: 4,
// //             textAlign: "left",
// //             fontFamily: "Poppins, sans-serif",
// //           }}
// //         >
// //           <Typography variant="h6" fontWeight={600} gutterBottom sx={{ fontFamily: "poppins" }}>
// //             Class Schedules:
// //           </Typography>
// //           <Typography sx={{ fontFamily: "poppins" }}>
// //             📅 <strong>Monday - Friday:</strong> Morning: 6 AM – 7 AM | Evening: 6 PM – 7 PM
// //           </Typography>
// //           <Typography sx={{ fontFamily: "poppins" }}>
// //             📅 <strong>Weekend Therapy Classes:</strong> Saturday & Sunday: 7 AM – 8 AM
// //           </Typography>
// //         </Box>

// //         {/* Pricing Section */}
// //         <Box
// //           sx={{
// //             my: 4,
// //             textAlign: "left",
// //             fontFamily: "Poppins, sans-serif",
// //           }}
// //         >
// //           <Typography variant="h6" fontWeight={600} gutterBottom sx={{ fontFamily: "poppins" }}>
// //             Class Pricing:
// //           </Typography>
// //           <Typography sx={{ fontFamily: "poppins" }}>
// //             💰 <strong>Group Classes:</strong> $150/month (3 classes per week)
// //           </Typography>
// //           <Typography   sx={{ fontFamily: "poppins" }}>
// //             💰 <strong>Private Classes:</strong> $250/month (3 classes per week)
// //           </Typography>
// //           <Typography sx={{ fontFamily: "poppins" }}>
// //             💰 <strong>Therapy Classes:</strong> Discussed as per health conditions
// //           </Typography>
// //         </Box>

// //         <Typography sx={{ fontFamily: "poppins" }}>
// //            Scan To Chat With Us
// //           </Typography>
// //         <Box
// //           sx={{
// //             width: 150,
// //             height: 150,
// //             bgcolor: "grey.300",
// //             mx: "auto",
// //             mt: 4,
// //             display: "flex",
// //             alignItems: "center",
// //             justifyContent: "center",
// //             borderRadius: 2,
// //           }}
// //         >
// //            <Box component={"img"} src={qr} sx={{objectFit:"cover",width:150,height:150}} />
// //         </Box>

// //       </Paper>
// //     </Container>
// //   );
// // };

// // export default ContactHero;

import React from "react";
import { Box, Container, Typography, Paper } from "@mui/material";
import { motion } from "framer-motion";
import qr from "../../images/barcode.jpeg"; // Adjust path based on your project structure

const ContactHero = () => {
  // Animation variants for fade-in effect
  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  // Animation variants for hover effect
  const hoverEffect = {
    hover: { scale: 1.05, transition: { duration: 0.3 } },
  };

  return (
    <Container
      maxWidth="lg" // Slightly wider container for better spacing
      sx={{
        py: { xs: 4, md: 8 },
        fontFamily: "'Poppins', sans-serif",
        // background: "linear-gradient(180deg, #FFEBC1 0%, #FFD59A 0%)", // Soft gradient background
      }}
    >
      <Paper
        component={motion.div}
        initial="hidden"
        animate="visible"
        variants={fadeIn}
        elevation={8}
        sx={{
          p: { xs: 3, md: 6 },
          borderRadius: 4,
          border: "none",
          background: "rgba(255, 255, 255, 0.9)", // Semi-transparent white for a clean look
          backdropFilter: "blur(10px)", // Glassmorphism effect
          textAlign: "center",
          fontFamily: "'Poppins', sans-serif",
          boxShadow: "0 8px 32px rgba(8, 226, 175, 0.1)",
        }}
      >
        {/* Title Section */}
        <Typography
          component={motion.div}
          variants={fadeIn}
          variant="h3"
          fontWeight={700}
          gutterBottom
          sx={{
            fontFamily: "'Poppins', sans-serif",
            color: "#2A4B7C", // Deep blue for calming effect
            mb: 3,
          }}
        >
          Questions or Concerns?
        </Typography>

        {/* Description Section */}
        <Typography
          component={motion.div}
          variants={fadeIn}
          variant="body1"
          sx={{
            mb: 3,
            fontFamily: "'Poppins', sans-serif",
            color: "#4A5568", // Soft gray for text
            lineHeight: 1.8,
            fontSize: { xs: "1rem", md: "1.1rem" },
          }}
        >
          Feel free to contact us with any questions or inquiries about Yoga
          therapy classes for private consultations with a mindful approach,
          specializing in stress-related conditions such as adrenal fatigue,
          IBS, insomnia, depression, anxiety, weight loss, and overall fitness.
        </Typography>

        <Typography
          component={motion.div}
          variants={fadeIn}
          variant="body1"
          sx={{
            mb: 4,
            fontFamily: "'Poppins', sans-serif",
            color: "#4A5568",
            lineHeight: 1.8,
            fontSize: { xs: "1rem", md: "1.1rem" },
          }}
        >
          Our sessions help people overcome stress, back and knee pain, anxiety,
          hypertension, depression, and psychosomatic disorders. Learn more
          about our class schedules.
        </Typography>

        {/* Contact Information Section */}
        <Box
          component={motion.div}
          variants={fadeIn}
          sx={{
            my: 4,
            textAlign: "left",
            fontFamily: "'Poppins', sans-serif",
            p: 3,
            borderRadius: 2,
            // background: "linear-gradient(135deg, #E6F0FA 0%, #EDF2F7 100%)", // Subtle gradient
            background: "linear-gradient(180deg, #FFEBC1 0%, #FFD59A 0%)",
          }}
        >
          <Typography
            variant="h6"
            fontWeight={600}
            gutterBottom
            sx={{ fontFamily: "'Poppins', sans-serif", color: "#2A4B7C" }}
          >
            Contact Information:
          </Typography>
          <Typography
            sx={{ fontFamily: "'Poppins', sans-serif", color: "#4A5568" }}
          >
            Email: pranayoga.us@gmail.com
          </Typography>
          <Typography
            sx={{ fontFamily: "'Poppins', sans-serif", color: "#4A5568" }}
          >
            Phone: 425-524-2725
          </Typography>
          <Typography
            sx={{ fontFamily: "'Poppins', sans-serif", color: "#4A5568" }}
          >
            Location: Prana Yoga and Meditation, Naperville, IL
          </Typography>
        </Box>

        {/* Class Schedules Section */}
        {/* <Box
          component={motion.div}
          variants={fadeIn}
          sx={{
            my: 4,
            textAlign: "left",
            fontFamily: "'Poppins', sans-serif",
            p: 3,
            borderRadius: 2,
            // background: "linear-gradient(135deg, #E6F0FA 0%, #EDF2F7 100%)",
            background: "linear-gradient(180deg, #FFEBC1 0%, #FFD59A 0%)",
          }}
        >
          <Typography
            variant="h6"
            fontWeight={600}
            gutterBottom
            sx={{ fontFamily: "'Poppins', sans-serif", color: "#2A4B7C" }}
          >
            Class Schedules:
          </Typography>
          <Typography
            sx={{ fontFamily: "'Poppins', sans-serif", color: "#4A5568" }}
          >
            📅 <strong>Monday - Friday:</strong> Morning: 6 AM – 7 AM | Evening:
            6 PM – 7 PM
          </Typography>
          <Typography
            sx={{ fontFamily: "'Poppins', sans-serif", color: "#4A5568" }}
          >
            📅 <strong>Weekend Therapy Classes:</strong> Saturday & Sunday: 7 AM
            – 8 AM
          </Typography>
        </Box> */}
        {/* Class Schedules Section */}
        <Box
          component={motion.div}
          variants={fadeIn}
          sx={{
            my: 4,
            textAlign: "left",
            fontFamily: "'Poppins', sans-serif",
            p: 3,
            borderRadius: 2,
            background: "linear-gradient(180deg, #FFEBC1 0%, #FFD59A 0%)",
          }}
        >
          <Typography
            variant="h6"
            fontWeight={600}
            gutterBottom
            sx={{ fontFamily: "'Poppins', sans-serif", color: "#2A4B7C" }}
          >
            Class Schedules:
          </Typography>

          {/* Weekdays */}
          <Typography
            sx={{
              fontFamily: "'Poppins', sans-serif",
              color: "#4A5568",
              fontWeight: 600,
              mt: 2,
            }}
          >
            📅 Weekdays:
          </Typography>
          <ul
            style={{ paddingLeft: "1rem", marginTop: "4px", color: "#4A5568" }}
          >
            <li style={{ marginBottom: "4px" }}>Morning: 6:00 AM – 7:00 AM & 6:00 PM – 7:00 PM</li>
            <li>Evening: 7:00 PM – 8:00 PM</li>
          </ul>

          {/* Weekends */}
          <Typography
            sx={{
              fontFamily: "'Poppins', sans-serif",
              color: "#4A5568",
              fontWeight: 600,
              mt: 2,
            }}
          >
            📅 Weekends:
          </Typography>
          <ul
            style={{ paddingLeft: "1rem", marginTop: "4px", color: "#4A5568" }}
          >
            <li style={{ marginBottom: "4px" }}>Morning: 6:00 AM – 7:00 AM & 7:00 AM – 8:00 AM</li>
            <li> Evening: 6:00 PM – 7:00 PM</li>
          </ul>
        </Box>

        {/* Pricing Section */}
        <Box
          component={motion.div}
          variants={fadeIn}
          sx={{
            my: 4,
            textAlign: "left",
            fontFamily: "'Poppins', sans-serif",
            p: 3,
            borderRadius: 2,
            // background: "linear-gradient(135deg, #E6F0FA 0%, #EDF2F7 100%)",
            background: "linear-gradient(180deg, #FFEBC1 0%, #FFD59A 0%)",
          }}
        >
          <Typography
            variant="h6"
            fontWeight={600}
            gutterBottom
            sx={{ fontFamily: "'Poppins', sans-serif", color: "#2A4B7C" }}
          >
            Class Pricing:
          </Typography>
          <Typography
            sx={{ fontFamily: "'Poppins', sans-serif", color: "#4A5568" }}
          >
            💰 <strong>Group Classes:</strong> $120/month (5 classes per week)
          </Typography>
          <Typography
            sx={{ fontFamily: "'Poppins', sans-serif", color: "#4A5568" }}
          >
            💰 <strong>Private Classes:</strong> $250/month (5 classes per week)
          </Typography>
          <Typography
            sx={{ fontFamily: "'Poppins', sans-serif", color: "#4A5568" }}
          >
            💰 <strong>Therapy Classes:</strong> Discussed as per health
            conditions
          </Typography>
        </Box>

        {/* QR Code Section */}
        <Typography
          component={motion.div}
          variants={fadeIn}
          sx={{
            fontFamily: "'Poppins', sans-serif",
            color: "#2A4B7C",
            fontWeight: 500,
            mb: 2,
          }}
        >
          Scan To Chat With Us
        </Typography>
        <Box
          component={motion.div}
          variants={fadeIn}
          whileHover="hover"
          sx={{
            width: 150,
            height: 150,
            mx: "auto",
            mt: 2,
            borderRadius: 2,
            overflow: "hidden",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          }}
        >
          <Box
            component="img"
            src={qr}
            alt="QR Code to Contact Prana Yoga"
            sx={{ objectFit: "cover", width: "100%", height: "100%" }}
          />
        </Box>
      </Paper>
    </Container>
  );
};

export default ContactHero;

// import React from "react";
// import { Box, Container, Typography, Paper } from "@mui/material";
// import { motion } from "framer-motion";
// import qr from "../../images/QR.jpeg"; // Adjust path based on your project structure
// import yogaBackground from "../../images/heroImage.jpeg"; // Yoga-themed background image

// const ContactHero = () => {
//   // Animation variants for fade-in effect
//   const fadeIn = {
//     hidden: { opacity: 0, y: 20 },
//     visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
//   };

//   // Animation variants for hover effect
//   const hoverEffect = {
//     hover: { scale: 1.05, transition: { duration: 0.3 } },
//   };

//   return (
//     <Container
//       maxWidth="xxl"
//       sx={{
//         py: { xs: 4, md: 8 },
//         fontFamily: "'Poppins', sans-serif",
//         backgroundImage: `url(${yogaBackground})`, // Fixed background image
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//         backgroundAttachment: "fixed", // Parallax effect
//         backgroundRepeat: "no-repeat",
//         position: "relative",
//         "&::before": {
//           content: '""',
//           position: "absolute",
//           top: 0,
//           left: 0,
//           width: "100%",
//           height: "100%",
//           background: "linear-gradient(180deg, rgba(230, 240, 250, 0.8) 0%, rgba(246, 249, 252, 0.8) 100%)", // Subtle overlay for readability
//           zIndex: 0,
//         },
//       }}
//     >
//       <Paper
//         component={motion.div}
//         initial="hidden"
//         animate="visible"
//         variants={fadeIn}
//         elevation={8}
//         sx={{
//           p: { xs: 3, md: 6 },
//           borderRadius: 4,
//           border: "none",
//           background: "rgba(255, 255, 255, 0.9)",
//           backdropFilter: "blur(10px)",
//           textAlign: "center",
//           fontFamily: "'Poppins', sans-serif",
//           boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
//           position: "relative",
//           zIndex: 1, // Above background overlay
//         }}
//       >
//         {/* Title Section */}
//         <Typography
//           component={motion.div}
//           variants={fadeIn}
//           variant="h3"
//           fontWeight={700}
//           gutterBottom
//           sx={{
//             fontFamily: "'Poppins', sans-serif",
//             color: "#2A4B7C",
//             mb: 3,
//           }}
//         >
//           Questions or Concerns?
//         </Typography>

//         {/* Description Section */}
//         <Typography
//           component={motion.div}
//           variants={fadeIn}
//           variant="body1"
//           sx={{
//             mb: 3,
//             fontFamily: "'Poppins', sans-serif",
//             color: "#4A5568",
//             lineHeight: 1.8,
//             fontSize: { xs: "1rem", md: "1.1rem" },
//           }}
//         >
//           Feel free to contact us with any questions or inquiries about Yoga therapy classes for private consultations with a mindful approach, specializing in stress-related conditions such as adrenal fatigue, IBS, insomnia, depression, anxiety, weight loss, and overall fitness.
//         </Typography>

//         <Typography
//           component={motion.div}
//           variants={fadeIn}
//           variant="body1"
//           sx={{
//             mb: 4,
//             fontFamily: "'Poppins', sans-serif",
//             color: "#4A5568",
//             lineHeight: 1.8,
//             fontSize: { xs: "1rem", md: "1.1rem" },
//           }}
//         >
//           Our sessions help people overcome stress, back and knee pain, anxiety, hypertension, depression, and psychosomatic disorders. Learn more about our class schedules.
//         </Typography>

//         {/* Contact Information Section */}
//         <Box
//           component={motion.div}
//           variants={fadeIn}
//           sx={{
//             my: 4,
//             textAlign: "left",
//             fontFamily: "'Poppins', sans-serif",
//             p: 3,
//             borderRadius: 2,
//             background: "linear-gradient(135deg, #E6F0FA 0%, #EDF2F7 100%)",
//           }}
//         >
//           <Typography
//             variant="h6"
//             fontWeight={600}
//             gutterBottom
//             sx={{ fontFamily: "'Poppins', sans-serif", color: "#2A4B7C" }}
//           >
//             Contact Information:
//           </Typography>
//           <Typography sx={{ fontFamily: "'Poppins', sans-serif", color: "#4A5568" }}>
//             Email: pranayoga.us@gmail.com
//           </Typography>
//           <Typography sx={{ fontFamily: "'Poppins', sans-serif", color: "#4A5568" }}>
//             Phone: 425-524-2725
//           </Typography>
//           <Typography sx={{ fontFamily: "'Poppins', sans-serif", color: "#4A5568" }}>
//             Location: Prana Yoga and Meditation, Naperville, IL
//           </Typography>
//         </Box>

//         {/* Class Schedules Section */}
//         <Box
//           component={motion.div}
//           variants={fadeIn}
//           sx={{
//             my: 4,
//             textAlign: "left",
//             fontFamily: "'Poppins', sans-serif",
//             p: 3,
//             borderRadius: 2,
//             background: "linear-gradient(135deg, #E6F0FA 0%, #EDF2F7 100%)",
//           }}
//         >
//           <Typography
//             variant="h6"
//             fontWeight={600}
//             gutterBottom
//             sx={{ fontFamily: "'Poppins', sans-serif", color: "#2A4B7C" }}
//           >
//             Class Schedules:
//           </Typography>
//           <Typography sx={{ fontFamily: "'Poppins', sans-serif", color: "#4A5568" }}>
//             📅 <strong>Monday - Friday:</strong> Morning: 6 AM – 7 AM | Evening: 6 PM – 7 PM
//           </Typography>
//           <Typography sx={{ fontFamily: "'Poppins', sans-serif", color: "#4A5568" }}>
//             📅 <strong>Weekend Therapy Classes:</strong> Saturday & Sunday: 7 AM – 8 AM
//           </Typography>
//         </Box>

//         {/* Pricing Section */}
//         <Box
//           component={motion.div}
//           variants={fadeIn}
//           sx={{
//             my: 4,
//             textAlign: "left",
//             fontFamily: "'Poppins', sans-serif",
//             p: 3,
//             borderRadius: 2,
//             background: "linear-gradient(135deg, #E6F0FA 0%, #EDF2F7 100%)",
//           }}
//         >
//           <Typography
//             variant="h6"
//             fontWeight={600}
//             gutterBottom
//             sx={{ fontFamily: "'Poppins', sans-serif", color: "#2A4B7C" }}
//           >
//             Class Pricing:
//           </Typography>
//           <Typography sx={{ fontFamily: "'Poppins', sans-serif", color: "#4A5568" }}>
//             💰 <strong>Group Classes:</strong> $150/month (3 classes per week)
//           </Typography>
//           <Typography sx={{ fontFamily: "'Poppins', sans-serif", color: "#4A5568" }}>
//             💰 <strong>Private Classes:</strong> $250/month (3 classes per week)
//           </Typography>
//           <Typography sx={{ fontFamily: "'Poppins', sans-serif", color: "#4A5568" }}>
//             💰 <strong>Therapy Classes:</strong> Discussed as per health conditions
//           </Typography>
//         </Box>

//         {/* QR Code Section */}
//         <Typography
//           component={motion.div}
//           variants={fadeIn}
//           sx={{
//             fontFamily: "'Poppins', sans-serif",
//             color: "#2A4B7C",
//             fontWeight: 500,
//             mb: 2,
//           }}
//         >
//           Scan To Chat With Us
//         </Typography>
//         <Box
//           component={motion.div}
//           variants={fadeIn}
//           whileHover="hover"
//           sx={{
//             width: 150,
//             height: 150,
//             mx: "auto",
//             mt: 2,
//             borderRadius: 2,
//             overflow: "hidden",
//             boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
//           }}
//         >
//           <Box
//             component="img"
//             src={qr}
//             alt="QR Code to Contact Prana Yoga"
//             sx={{ objectFit: "cover", width: "100%", height: "100%" }}
//           />
//         </Box>
//       </Paper>
//     </Container>
//   );
// };

// export default ContactHero;
